export const summaryPhrases = [
    "Aces", "Attacks", "Blocks", "Opp. Errors", "Total",
    "% Points SO", "% Points BP",
    "%S+", "%R#", "%Eff_R", "%A#", "%Eff_A",
    "Serve", "Block", "Transition", "Difference",
    "Sets"
];